import messages from '../../../locale/messages';
import { nameInputLimit } from '../../../helpers/FieldRestriction';

const validate = values => {
    const errors = {};

    if (!values?.firstName || values?.firstName?.toString().trim() == "") {
        errors.firstName = messages.required;
    } else if (values?.firstName?.length > nameInputLimit) {
        errors.firstName = messages.nameTextLimitError;
    }

    if (!values?.lastName || values?.lastName?.toString().trim() == "") {
        errors.lastName = messages.required;
    } else if (values?.lastName?.length > nameInputLimit) {
        errors.lastName = messages.nameTextLimitError;
    }

    if (!values.email || (values.email && values.email.toString().trim() === "")) {
        errors.email = messages.required;
    } else if (!values?.isRestrict && !/^[A-Z0-9.%+-_]+@[A-Z0-9.-_]+\.[A-Z]{2,6}$/i.test(values.email)) {
        errors.email = messages.emailInvalid;
    }

    if (!values.phoneNumber) {
        errors.phoneNumber = messages.required;
    } else if (!values?.isRestrict && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(values.phoneNumber)) {
        errors.phoneNumber = messages.phoneError;
    }

    if (!values.phoneDialCode) {
        errors.phoneDialCode = messages.required;
    }

    return errors;
};

export default validate